import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ recentQuiz, recommendedPlay }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <h2 className="text-2xl font-semibold text-card-foreground mb-4 flex items-center gap-2">
        <Icon name="Zap" size={24} color="var(--color-accent)" />
        Quick Actions
      </h2>
      <div className="space-y-4">
        {recentQuiz && (
          <div className="bg-gradient-to-r from-accent/10 to-accent/5 rounded-lg p-4 border border-accent/20">
            <div className="flex items-start gap-3 mb-3">
              <div className="flex-shrink-0 w-10 h-10 bg-accent rounded-lg flex items-center justify-center">
                <Icon name="Brain" size={20} color="white" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-card-foreground mb-1">Continue Quiz</h4>
                <p className="text-sm text-muted-foreground">{recentQuiz?.playTitle}</p>
                <p className="text-xs text-muted-foreground mt-1">{recentQuiz?.progress}% complete</p>
              </div>
            </div>
            <Button 
              variant="default" 
              fullWidth
              iconName="PlayCircle"
              iconPosition="left"
              onClick={() => navigate('/quiz-interface', { state: { quizId: recentQuiz?.id } })}
            >
              Resume Quiz
            </Button>
          </div>
        )}

        {recommendedPlay && (
          <div className="bg-gradient-to-r from-secondary/10 to-secondary/5 rounded-lg p-4 border border-secondary/20">
            <div className="flex items-start gap-3 mb-3">
              <div className="flex-shrink-0 w-10 h-10 bg-secondary rounded-lg flex items-center justify-center">
                <Icon name="BookOpen" size={20} color="var(--color-secondary-foreground)" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-card-foreground mb-1">Recommended for You</h4>
                <p className="text-sm text-muted-foreground">{recommendedPlay?.title}</p>
                <p className="text-xs text-muted-foreground mt-1">{recommendedPlay?.reason}</p>
              </div>
            </div>
            <Button 
              variant="outline" 
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/play-reading-interface', { state: { playId: recommendedPlay?.id } })}
            >
              Start Reading
            </Button>
          </div>
        )}

        <div className="grid grid-cols-2 gap-3">
          <Button 
            variant="outline"
            iconName="Search"
            iconPosition="left"
            onClick={() => {}}
          >
            Browse Plays
          </Button>
          <Button 
            variant="outline"
            iconName="BookText"
            iconPosition="left"
            onClick={() => {}}
          >
            Glossary
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;